import { createRouter, createWebHistory } from "vue-router";
import PostSection from "@/components/website/welcome/PostSection.vue";
import FeedbackSection from "@/components/website/welcome/FeedbackSection.vue";
import TeamSection from "@/components/website/welcome/TeamSection.vue";
import ContactSection from "@/components/website/welcome/ContactSection.vue";
import FooterSection from "@/components/website/welcome/FooterSection.vue";
import PostPage from "@/views/website/PostPage.vue";
import SignInView from "../views/website/Sign-InView.vue";
import HomePageView from "@/views/website/HomeView.vue";
import DashboardView from "@/views/admin/DashboardView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePageView,
  },
  {
    path: "/suggested",
    name: "postpage",
    component: PostPage,
  },
  {
    path: "/posts",
    name: "posts",
    component: PostSection,
  },
  {
    path: "/feedback",
    name: "feedback",
    component: FeedbackSection,
  },
  {
    path: "/teams",
    name: "teams",
    component: TeamSection,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactSection,
  },
  {
    path: "/footer",
    name: "footer",
    component: FooterSection,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/website/welcome/AboutSection.vue"
      ),
  },
  {
    path: "/signin",
    name: "/signin",
    // route level code-splitting
    // this generates a separate chunk (signin.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: SignInView,
    // component: () =>
    //   import(/* webpackChunkName: "signin" */ "../views/Sign-InView.vue"),
  },
  {
    path: "/signup",
    name: "/signup",
    // route level code-splitting
    // this generates a separate chunk (signup.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "signup" */ "../views/website/Sign-UpView.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
